/* eslint-disable */
import httpAddScript from '../../../../Support/Http/AddScript/HttpAddScript.support';
import isFunction from '../../../../Support/Is/Function/IsFunction';
import AnalyticsAdapter from '../Analytics.adapter';

/**
 * AnalyticsGoogleTagManagerAdapter
 * @class AnalyticsGoogleTagManagerAdapter
 * @implements {AnalyticsServiceAdapterContract}
 * @extends {AnalyticsAdapter}
 */
class AnalyticsGoogleTagManagerAdapter extends AnalyticsAdapter {
  /**
   * The AnalyticsGoogleTagManagerAdapter specific config
   * @type {AnalyticsGoogleTagManagerAdapterConfig}
   * @memberof AnalyticsGoogleTagManagerAdapter
   */
  _config;

  /**
   * Creates an instance of AnalyticsGoogleTagManagerAdapter
   * @param {AnalyticsGoogleTagManagerAdapterCreateDto} dto The params required to create an instance of `AnalyticsGoogleTagManagerAdapter`
   * @memberof AnalyticsGoogleTagManagerAdapter
   */
  constructor({ config }) {
    super();
    this._config = config;
    this._init();
  }

  /**
   * Initalise Google Tag Manager
   * @returns {void} void
   * @memberof AnalyticsGoogleTagManagerAdapter
   */
  _init = () => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: `gtm.js`,
      'gtm.start': Date.now(),
    });
    this.addScript();
  };

  /**
   * Add the Google Tag Manager script to the page
   * @returns {void} void
   * @memberof AnalyticsGoogleTagManagerAdapter
   */
  addScript = () => {
    const { gtmKey } = this._config;
    const src = `https://www.googletagmanager.com/gtm.js?id=${gtmKey}`;
    httpAddScript({ src });
  };

  /**
   * Track an event
   * @param {AnalyticsEvent} event The event to track
   * @returns {void} void
   * @memberof AnalyticsGoogleTagManagerAdapter
   */
  track = (event) => {
    if (window.dataLayer === undefined || !isFunction(window.dataLayer.push)) {
      return;
    }
    window.dataLayer.push(event.payload);
  };
}

export default AnalyticsGoogleTagManagerAdapter;
